export default "__VITE_ASSET__942c8cc4__"